export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'Un type d\'indicateur du même nom existe déjà'
    }
  }
}
